import { forEach, isElement } from 'lodash';

const
    moduleName = 'accordion',
    selectors = {
        base: `.js-${moduleName}`,
        trigger: `.js-${moduleName}-trigger`,
        target: `.js-${moduleName}-target`
    };

export class Accordion {

    constructor(baseElement) {
        if (!isElement(baseElement)) {
            return false;
        }

        this._configure(baseElement);
        this._setup();
    }

    /* ================== EVENT HANDLING ===================== */

    _handleTriggerClicked(event) {
        const trigger = event.currentTarget || event.target,
            id = trigger.id,
            target = this.baseElement.querySelector(`#panel-${id}`),
            expanded = trigger.getAttribute('aria-expanded') === 'true' || false;

        trigger.setAttribute('aria-expanded', !expanded);
        target.hidden = expanded;
    }

    _bindEvents() {
        forEach(this.triggers, (trigger) => {
            trigger.addEventListener('click', (ev) => this._handleTriggerClicked(ev));
        });
    }

    /* ================== EVENT HANDLING ===================== */


    /* ================== INITIALIZATION ===================== */

    _configure(baseElement) {
        this.baseElement = baseElement;
        this.triggers = this.baseElement.querySelectorAll(selectors.trigger);
    }

    _setup() {
        this._bindEvents();
    }

    /* ================== INITIALIZATION ===================== */
}

function init(baseElements = document.querySelectorAll(selectors.base)) {
    forEach(baseElements, baseElement => {
        new Accordion(baseElement);
    });
}

init();